<template>
  <form @submit.prevent="submit">
    <fields layout="vertical" />
    <b-button type="submit" variant="primary">
      {{ $t('general.save') }}
    </b-button>
    <b-button type="button" variant="light" class="ml-2" @click="cancel">
      {{ $t('general.cancel') }}
    </b-button>
  </form>
</template>

<script>
import FieldList from '../stylemix-base/utils/FieldList'
import ResourceFormMixin from '../stylemix-vue-admin/mixins/ResourceFormMixin'
import TransferFixedRidePricesApi from './TransferFixedRidePricesApi'

export default {
  mixins: [ResourceFormMixin],

  props: {
    companyId: {
      type: Number,
      default: null,
    },
    airportId: {
      type: Number,
      default: null,
    },
    vehicleId: {
      type: Number,
      default: null,
    },
    anyDivision: {
      type: Number,
      default: 1,
    },
  },

  mounted() {
    this.loadForm().then(() => {
      if (!this.updating) {
        this.model.airport_id = this.airportId
        this.model.vehicle_id = this.vehicleId
        this.model.any_division = this.anyDivision
        if (this.companyId) {
          this.model.company_id = this.companyId
        }
      }

      this.$emit('loaded')
    })
  },

  methods: {
    api() {
      const params = {}
      if (this.companyId) {
        params.company_id = this.companyId
      }
      params.any_division = this.anyDivision

      return new TransferFixedRidePricesApi(params)
    },

    submit() {
      this.save().then((result) => {
        this.$toast.success(result.message)
      })
    },

    setFields(fields) {
      if (!this.updating) {
        fields = [
          ...fields,
          {
            attribute: 'vehicle_id',
            component: 'hidden-field',
            value: this.vehicleId,
          },
          {
            attribute: 'airport_id',
            component: 'hidden-field',
            value: this.airportId,
          },
        ]

        if (this.companyId) {
          fields.push({
            attribute: 'company_id',
            component: 'hidden-field',
            value: this.companyId,
          })
        }
      }
      this.fields = new FieldList(fields, this.errors)
    },
  },
}
</script>
